import { render, staticRenderFns } from "./IndustryCard.vue?vue&type=template&id=b8d9eba6&"
import script from "./IndustryCard.vue?vue&type=script&lang=js&"
export * from "./IndustryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports